export default __webpack_public_path__ + "static/media/p9.c3bfbd4e.jpg";